export class User {
    moduleId: string;
    username: string;
    password: string;
    ipAddress: string;
    machineName: string;
    browser: string;
    os: string;
    ReCaptchaResponse?: string;
    token?:string;
}